import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.vendor/picker/vendor-picker-table.htm";
//import customerConfig from "emun.customer/customer.config";
import VendorParser from "emun.vendor/parser/vendor-parser";
//import ApplyTagsPrompt from "emun.customer/picker/apply-retailer-tags-prompt";

//export const filters = customerConfig.filters;

export const views = {
	list: "table",
	//  cards: "th-large"
};

export default class VendorPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setVendorIds();
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
		//$ctrl.viewSelectionsChanged(); //load()
	}

	templateUrl = () => `vendor-picker-${this.query.view}.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.id] = true));
		this.setVendorIds();
	}
	clearAll() {
		this.selected = {};
		this.setVendorIds();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(vendor) {
		return !!this.selected[vendor.id];
	}

	setVendorIds() {
		this.vendorIds = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { vendorIds: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(vendor) {
		const $ctrl = this;
		console.log("toggle", vendor.id, $ctrl.selected, vendor);

		if ($ctrl.single) {
			$ctrl.$close(vendor);
		} else if (vendor.id in $ctrl.selected) {
			delete $ctrl.selected[vendor.id];
			$ctrl.onVendorUnSelected &&
				$ctrl.onVendorUnSelected({ $vendor: vendor, ...$ctrl });
		} else {
			$ctrl.selected[vendor.id] = true;
			$ctrl.onVendorSelected &&
				$ctrl.onVendorSelected({ $vendor: vendor, ...$ctrl });
		}
		this.setVendorIds();
	}
	select(vendor) {
		const $ctrl = this;
		$ctrl.$close([vendor]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	parseVendors() {
		const $ctrl = this;
		VendorParser({}).then(vendorIds => {
			$ctrl.selected = {};
			vendorIds.forEach(vendorId => {
				$ctrl.toggle({ id: vendorId });
			});
			$ctrl.viewSelections = true;
			$ctrl.viewSelectionsChanged();
		});
	}

	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryVendors.json",
			pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
			views,
			criteria: $ctrl.criteria,
			view: "table",
//			filters,
			sortOptions: {
				"Label": "Name: A to Z",
				"-Label": "Name: Z to A"
			},
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: "Label,Id",
			autoLoad: true,
			append: false
		};
	}
}


